import icTop from "@/assets/images/user/icTop.svg";
import logo from "@/assets/images/user/logo.svg";

import SnsLink from "./SnsLink";

export default function Footer() {
    // 스크롤위치 맨위로 이동
    const handleScrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        <footer className="relative">
            <button
                type="button"
                className="absolute right-[20px] top-0 z-[1] flex size-[50px] -translate-y-1/2 flex-col items-center justify-center gap-[4px] bg-primary md:left-1/2 md:size-[100px] md:-translate-x-1/2 md:gap-[12px]"
                onClick={handleScrollToTop}
            >
                <img src={icTop} alt="화살표" className="h-[8px] md:h-auto" />
                <p className="font-['Handjet'] text-white md:text-[24px]">TOP</p>
            </button>
            <div className="bg-[#000] py-[25px] md:py-[40px] xl:py-[60px]">
                <div className="relative mx-auto w-full max-w-[1400px] px-[16px] md:px-[20px] xl:flex xl:items-start xl:justify-between xl:px-0">
                    <div className="flex flex-col items-start gap-[20px] md:gap-[28px] xl:flex-row xl:items-center xl:gap-[40px]">
                        <img src={logo} alt="GXG" />
                        <div className="hidden xl:block xl:h-[32px] xl:w-[1px] xl:bg-white" />
                        <SnsLink />
                    </div>
                    <ul className="flex w-full flex-col gap-[9px] py-[24px] text-[14px] text-white md:py-[36px] md:text-[16px] xl:max-w-[600px] xl:py-0">
                        <li className="flex items-center">
                            <b className="w-[100px] md:w-[140px]">COMPANY</b>
                            <span>(재) 게임문화재단</span>
                        </li>
                        <li className="flex items-center">
                            <b className="w-[100px] md:w-[140px]">ADDRESS</b>
                            <span>서울특별시 서초구 방배로 114, 2층</span>
                        </li>
                        <li className="flex items-center">
                            <b className="w-[100px] md:w-[140px]">대표자</b>
                            <span>유병한</span>
                        </li>
                        <li className="flex items-center">
                            <b className="w-[100px] md:w-[140px]">사업자등록번호</b>
                            <span>105-82-16443</span>
                        </li>
                        <li className="flex items-center">
                            <b className="w-[100px] md:w-[140px]">E-mail</b>
                            <span>info@gxg.world</span>
                        </li>
                    </ul>
                    <p className="text-[14px] text-white md:text-[16px] xl:absolute xl:bottom-0 xl:left-0">
                        Copyright ⓒ (재) 게임문화재단. All rights reserved.
                    </p>
                </div>
            </div>
        </footer>
    );
}
